import React from "react";
import { Box } from "@mui/material";
const PDFReader = ({ file, showToolBar, setSVal }) => {
  const ref = React.useRef();
  let handleScroll = (sc) => {
    let element = sc.target;
    //console.log(element.scrollHeight);
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      setSVal(true);
    }
  };
  React.useEffect(() => {
    const reader = new FileReader();
    reader.addEventListener("load", (e) => {
      ref.current.src = showToolBar
        ? e.target.result + "#toolbar=0"
        : e.target.result;
    });
    const handle = async () => {
      const pdfstr = await fetch(file);
      const blobFromFetch = await pdfstr.blob();
      var blob = new Blob([blobFromFetch], { type: "application/pdf" });
      reader.readAsDataURL(blob);
    };
    handle();
  }, []);

  return (
    <Box>
      <iframe
        src=""
        height="400"
        width="100%"
        ref={ref}
        title="pdf"
        onScroll={handleScroll}
      ></iframe>
    </Box>
  );
};

export default PDFReader;
